var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcApagadoMotorDesactivado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#040006;}.cls-3{fill:#9e4502;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-apagado-motor-desactivado") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_34",
    "data-name": 34
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.07,58.49v4.59H122.86V86.21h36.47a.42.42,0,0,1,.42.42v29.8h16.67V101.32h5.42v40.33h-5.42v-14.8H160.16v12.71a.8.8,0,0,1-.24.58l-22.27,21.93a2.89,2.89,0,0,1-2,.84H95a2.9,2.9,0,0,1-2.15-1L80.08,147.81l-2-2.2H68.15a4.07,4.07,0,0,1-4.07-4.07V126.85H44.91V145.4H39.49V103.51h5.42v18.55H64.08V108a4.07,4.07,0,0,1,4.07-4.06h9.57l2-2.26L92.49,87.19a2.91,2.91,0,0,1,2.18-1h22.56V63.08H101.6V58.49h36.47m2.82-6.67H98.79a3.86,3.86,0,0,0-3.86,3.86V65.89a3.85,3.85,0,0,0,3.86,3.85h11.77v9.8H94.67a9.56,9.56,0,0,0-7.18,3.24L74.71,97.26H68.15A10.72,10.72,0,0,0,57.42,108v7.4H51.58v-15A3.55,3.55,0,0,0,48,96.84H36.37a3.55,3.55,0,0,0-3.55,3.54v48.15a3.55,3.55,0,0,0,3.55,3.54H48a3.55,3.55,0,0,0,3.54-3.54v-15h5.84v8a10.73,10.73,0,0,0,10.73,10.74h7l12.78,14.14a9.59,9.59,0,0,0,7.1,3.16h40.6a9.58,9.58,0,0,0,6.72-2.76l22.27-21.93a7.48,7.48,0,0,0,2.23-5.33v-6h2.92v11a3.81,3.81,0,0,0,3.8,3.81h11.16a3.81,3.81,0,0,0,3.8-3.81V98.45a3.8,3.8,0,0,0-3.8-3.8H173.55a3.8,3.8,0,0,0-3.8,3.8v11.31h-3.33V86.63a7.09,7.09,0,0,0-7.09-7.09h-29.8v-9.8h11.36a3.85,3.85,0,0,0,3.85-3.85V55.68a3.85,3.85,0,0,0-3.85-3.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 85.2,
    y: 108.38,
    width: 64.19,
    height: 28.7,
    rx: 14.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 135.08,
    cy: 122.73,
    r: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcApagadoMotorDesactivado);
export default __webpack_public_path__ + "static/media/ic-apagado-motor-desactivado.ebeacb5a98a57d5567f3110442d81251.svg";
export { ForwardRef as ReactComponent };